import { required } from "vuelidate/lib/validators";
import Message from "@/store/messages";
import api from "@/store/api.js";
import pagination from "@/store/pagination";

const artists = {
  namespaced: true,
  modules: {
    pg: pagination,
  },
  state: () => ({
    list: [],
    dropdown: [],
    current: null,
    create: {
      name: "",
    },
  }),
  mutations: {
    create(state, value) {
      state.create = value;
    },
    current(state, value) {
      state.current = value;
    },
    list(state, value) {
      state.list = value;
    },
    dropdown(state, value) {
      var selectList = [];
      value
        ? value.forEach((row, index) => {
            selectList[index] = {
              title: row["name"],
              label: row["name"],
              value: row["id"],
            };
          })
        : null;
      state.dropdown = selectList;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    current(state) {
      return state.current;
    },
    artistList(state) {
      return state.dropdown;
    },
    validations() {
      return {
        value: {
          name: { required },
        },
      };
    },
  },
  actions: {
    async create({ dispatch }) {
      await dispatch({ type: "createReq" });
      await dispatch({ type: "list" });
    },
    async update({ dispatch }) {
      await dispatch({ type: "updateReq" });
      await dispatch({ type: "list" });
    },
    async delete({ dispatch }, data) {
      await dispatch({ type: "deleteReq", data: data.data });
      await dispatch({ type: "list" });
    },
    createReq({ commit, state }) {
      return new Promise((resolve, reject) => {
        api
          .post("/events/artist", state.create)
          .then((response) => {
            commit("current", null);
            commit(
              "currentMsg",
              Message.getMessage("success", "artist.created"),
              { root: true }
            );
            resolve(response.data.payload);
          })
          .catch((error) => {
            commit("currentMsg", Message.getMessage("error", "error.unknown"), {
              root: true,
            });
            reject(error);
          });
      });
    },
    updateReq({ commit, state }) {
      return new Promise((resolve, reject) => {
        api
          .put("/events/artist", state.current)
          .then((response) => {
            commit("current", null);
            commit(
              "currentMsg",
              Message.getMessage("success", "artist.updated"),
              { root: true }
            );
            resolve(response.data.payload);
          })
          .catch((error) => {
            commit("currentMsg", Message.getMessage("error", "error.unknown"), {
              root: true,
            });
            reject(error);
          });
      });
    },
    deleteReq({ commit }, data) {
      return new Promise((resolve, reject) => {
        api
          .delete("/events/artist/" + data.data)
          .then((response) => {
            commit("current", null);
            commit(
              "currentMsg",
              Message.getMessage("success", "artist.deleted"),
              { root: true }
            );
            resolve(response.data.payload);
          })
          .catch((error) => {
            commit("currentMsg", Message.getMessage("error", "error.unknown"), {
              root: true,
            });
            reject(error);
          });
      });
    },
    list({ commit }) {
      return new Promise((resolve, reject) => {
        api
          .get("/events/artist")
          .then((response) => {
            commit("list", response.data.payload ? response.data.payload : []);
            commit("dropdown", response.data.payload);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
export default artists;
